import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  CalendarCheck, Clock, Hourglass, CheckCircle2, XCircle, DollarSign, Sparkles, Tag,
} from "lucide-react";
import api from "../lib/api";
import { Skeleton } from "../components/ui/skeleton";

const STATUS = {
  pending: ["قيد المراجعة", "bg-amber-100 text-amber-700"],
  confirmed: ["مؤكد", "bg-emerald-100 text-emerald-700"],
  cancelled: ["ملغي", "bg-rose-100 text-rose-700"],
  rejected: ["مرفوض", "bg-rose-100 text-rose-700"],
  completed: ["مكتمل", "bg-sky-100 text-sky-700"],
  awaiting_payment: ["بانتظار الدفع", "bg-orange-100 text-orange-700"],
};

export default function Overview() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">{Array.from({ length: 8 }).map((_, i) => <Skeleton key={i} className="h-28 rounded-2xl" />)}</div>;

  const cards = [
    { label: "حجوزات اليوم", value: data.today_count, icon: CalendarCheck, color: "text-sky-600" },
    { label: "المواعيد القادمة", value: data.upcoming_count, icon: Clock, color: "text-indigo-600" },
    { label: "قيد المراجعة", value: data.pending_count, icon: Hourglass, color: "text-amber-600" },
    { label: "مؤكدة", value: data.confirmed_count, icon: CheckCircle2, color: "text-emerald-600" },
    { label: "ملغاة", value: data.cancelled_count, icon: XCircle, color: "text-rose-600" },
    { label: "إيرادات الشهر", value: `${data.monthly_revenue} ر.س`, icon: DollarSign, color: "text-green-600" },
    { label: "الخدمات النشطة", value: data.active_services, icon: Sparkles, color: "text-violet-600" },
    { label: "العروض النشطة", value: data.active_offers, icon: Tag, color: "text-pink-600" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">لوحة التحكم</h1>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c, i) => (
          <div key={i} className="rounded-2xl bg-card cb-card-shadow p-5" data-testid={`stat-card-${i}`}>
            <div className="flex items-center justify-between">
              <c.icon className={`h-6 w-6 ${c.color}`} />
            </div>
            <div className="text-2xl font-bold mt-3">{c.value}</div>
            <div className="text-sm text-muted-foreground mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-2xl bg-card cb-card-shadow p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold">أحدث الحجوزات</h2>
          <Link to="/admin/bookings" className="text-primary text-sm font-semibold">عرض الكل</Link>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-muted-foreground border-b border-border">
              <tr>
                <th className="text-start py-2 font-medium">الاسم</th>
                <th className="text-start py-2 font-medium">الجوال</th>
                <th className="text-start py-2 font-medium">التاريخ</th>
                <th className="text-start py-2 font-medium">الحالة</th>
                <th className="text-start py-2 font-medium">الإجمالي</th>
              </tr>
            </thead>
            <tbody>
              {data.recent.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-muted-foreground">لا توجد حجوزات</td></tr>}
              {data.recent.map((b) => (
                <tr key={b.id} className="border-b border-border/60">
                  <td className="py-2.5 font-medium">{b.customer.name}</td>
                  <td className="py-2.5" dir="ltr">{b.customer.phone}</td>
                  <td className="py-2.5">{b.date} · {b.time}</td>
                  <td className="py-2.5"><span className={`px-2.5 py-1 rounded-full text-xs font-medium ${STATUS[b.status]?.[1]}`}>{STATUS[b.status]?.[0] || b.status}</span></td>
                  <td className="py-2.5 font-semibold">{b.total} ر.س</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
